import Vue from 'vue';

const upload = ({ file, type, options }) => {
  const data = new FormData();
  data.append('type', type);
  data.append('file', file);
  data.append('options', JSON.stringify(options));

  return Vue.axios.post('uploads', data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export default {
  namespaced: true,
  state: {
  },
  mutations: {
    /* eslint-disable no-param-reassign */
    /* eslint-enable no-param-reassign */
  },
  actions: {
    image(context, { file, options }) {
      return upload({
        file,
        type: 'image',
        options,
      });
    },
    upload(context, { file, type, options }) {
      const data = new FormData();
      data.append('type', type);
      data.append('file', file);
      data.append('options', options);

      return Vue.axios.post('uploads', data, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
    },
  },
  getters: {
  },
};
